export const WelcomeDialogTranslationKeys = {
  title: 'SMWelcome_Title',
  description: 'SMWelcome_SomeInfo',
  descriptionSecondary: 'SMWelcome_Check',
  btnTxt: 'SMWelcome_Edit',
  backToSiteLinkTxt: 'SMWelcome_Back',
};
